var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalizationIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 4.5V2.25C11.25 1.0125 10.2375 0 9 0H2.25C1.0125 0 0 1.0125 0 2.25V18C0 19.2375 1.0125 20.25 2.25 20.25H20.25C21.4875 20.25 22.5 19.2375 22.5 18V6.75C22.5 5.5125 21.4875 4.5 20.25 4.5H11.25ZM4.5 18H2.25V15.75H4.5V18ZM4.5 13.5H2.25V11.25H4.5V13.5ZM4.5 9H2.25V6.75H4.5V9ZM4.5 4.5H2.25V2.25H4.5V4.5ZM9 18H6.75V15.75H9V18ZM9 13.5H6.75V11.25H9V13.5ZM9 9H6.75V6.75H9V9ZM9 4.5H6.75V2.25H9V4.5ZM19.125 18H11.25V15.75H13.5V13.5H11.25V11.25H13.5V9H11.25V6.75H19.125C19.7437 6.75 20.25 7.25625 20.25 7.875V16.875C20.25 17.4937 19.7437 18 19.125 18ZM18 9H15.75V11.25H18V9ZM18 13.5H15.75V15.75H18V13.5Z",
    fill: "#2783EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalizationIcon1);
export default __webpack_public_path__ + "static/media/personalization-icon1.15e34b2bdfe0b7cbfffb6f2d20626124.svg";
export { ForwardRef as ReactComponent };